import { ActivityIndicator } from "react-native"

// Having this file abstraction will make it easier to change loading spinners later if we need

export default ActivityIndicator
